import React from 'react';

export const BootstrapContext = React.createContext({
  bootstrap4: false
});
